/* istanbul ignore file */

import { createUseStyles } from '@glu/theming';

export default createUseStyles(({ palette: { primary, success }, spacing: { unit } }) => ({
  wrapper: {
    minWidth: 180,
    borderRadius: 5,
    boxShadow: '0px 1px 8px rgba(0,0,0,0.1)',
    padding: '15px !important',
    margin: 15,
    '&.highlighted': {
      border: `1px solid ${success.normal}`
    },
    height: 165,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  label: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'center',
    fontSize: 18,
    paddingBottom: 10,
    color: primary.normal
  },
  iconWrapper: {
    paddingBottom: 1.875 * unit,
    display: 'flex',
    justifyContent: 'center',
    '& svg': {
      height: 6.25 * unit,
      width: 6.25 * unit
    }
  },
  checkmark: {
    display: 'flex',
    justifyContent: 'flex-end',
    height: 3.5 * unit,
    '& svg': {
      fill: success.normal,
      height: 3.5 * unit,
      width: 3.5 * unit
    }
  }
}));
